import "./style.css";

export const OnlineEducation = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "60vh",
                padding: "20px",
            }}
        >
            <div
                style={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    padding: "40px",
                    borderRadius: "12px",
                    border: "2px solid #be9455",
                    maxWidth: "600px",
                }}
            >
                <h1
                    style={{
                        fontFamily: "Bebas Neue",
                        fontSize: "48px",
                        color: "#be9455",
                        marginBottom: "20px",
                    }}
                >
                    Radovi u toku
                </h1>
                <p
                    style={{
                        fontSize: "18px",
                        color: "#333",
                        lineHeight: "1.6",
                    }}
                >
                    Online edukacije su trenutno u pripremi. Uskoro će biti
                    dostupne!
                </p>
                <p
                    style={{
                        fontSize: "16px",
                        color: "#666",
                        marginTop: "20px",
                    }}
                >
                    Pratite nas na društvenim mrežama za najnovije informacije.
                </p>
            </div>
        </div>
    );
};
